var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightblue03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a7cbf0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35,30c9.98,0,18.25,7.35,19.74,16.92h-4.35l7.69,12.3,7.69-12.3h-4.81c-1.54-12.97-12.58-23.07-25.96-23.07-9.39,0-17.62,4.99-22.23,12.45l3.77,6.03c3.01-7.23,10.16-12.33,18.46-12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.23,63.69l-3.77-6.03c-3.01,7.24-10.15,12.34-18.46,12.34-9.98,0-18.25-7.35-19.73-16.92h4.35l-7.69-12.3-7.69,12.3h4.81c1.53,12.98,12.57,23.08,25.95,23.08,9.4,0,17.62-5,22.23-12.45Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.04,54.97c0-2.39-1.96-4.35-4.35-4.35h-13.37c-2.39,0-4.35,1.96-4.35,4.35v10.16h22.07v-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.63,41.5c0,3.66-2.97,6.63-6.63,6.63s-6.63-2.97-6.63-6.63,2.97-6.63,6.63-6.63,6.63,2.97,6.63,6.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue03);
export default __webpack_public_path__ + "static/media/lightblue03.067ba4bfa71420825a76abe0f779493c.svg";
export { ForwardRef as ReactComponent };